import React from 'react';
import KpiProgressBanner from './banner';
import KpiHistory from './history';
import {makeStyles} from '@material-ui/core/styles';
import {lightTheme} from '@components/@theme/lightTheme';
import {Moment} from 'moment';
import User from 'records/User';

interface RepProfileKpiPageProps {
  startDate: Moment;
  endDate: Moment;
  targetUser: User;
}

export const DashKpiPage: React.FC<RepProfileKpiPageProps> = props => {
  const {wrapper} = useStyles(lightTheme);
  return (
    <div className={wrapper}>
      <h2>KPIs</h2>
      {props.targetUser && <KpiProgressBanner {...props} />}
      <KpiHistory {...props} user={props.targetUser} />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  wrapper: {
    minWidth: '960px',
    boxSizing: 'border-box',
    padding: '24px',
    '& > div': {
      margin: '20px 0',
    },
  },
}));
